import * as React from "react";

import { MouseEventHandler } from "react";
import { Alert, Badge, Button, Form, FormGroup, Input, Label } from "reactstrap";
import { AuthenticatedResponse, UserProfile } from "../store/Interfaces";

import LoadingModal from "./LoadingModal";
import { AvForm, AvField } from "availity-reactstrap-validation";
import { Link } from "react-router-dom";
const theControlID = "UserProfile";
interface OwnProps {
}

interface EditorState {
  currentModel: UserProfile | undefined;
  isLoading: boolean;
  id: number | undefined;
  isError: boolean;
  isSuccess: boolean;
}
export class UserProfileDetails extends React.Component<OwnProps> {
  public state: EditorState = {
    isLoading: false,
    currentModel: undefined,
    id: undefined,
    isError: false,
    isSuccess: false
  };
  Save: MouseEventHandler<HTMLDivElement> | undefined;
  constructor(props: Readonly<OwnProps>) {
    super(props);
  }
  // This method is called when the component is first added to the document
  public componentDidMount() {
    this.ensureDataFetched();
  }
  handleInvalidSubmit = (event: any, errors: any, values: { email: any; }) => {
    this.setState({ email: values.email, error: true });
    // console.log(`Login failed`);

  };
  handleValidSubmit = (event: any, values: UserProfile) => {
    this.setState({
      isLoading: true, isError: false,
      isSuccess: false
    });

    values.id = this.state.id;
    fetch(
      process.env.REACT_APP_API_HOST + `/CABSBill/userprofile`, {
      method: "PUT",
      credentials: "include",
      body: JSON.stringify(values),
      headers: {
        pragma: "no-cache",
        "cache-control": "no-cache",
        'Authorization': 'Bearer ' + localStorage.getItem("accessToken"),
        "content-type": "application/json",
      },
    })
      .then((response) => {
        if (!response.ok) {

          this.catchNok(response);

        } else {


          return response.json() as Promise<AuthenticatedResponse>;

        }
      })
      .then((data) => {
        if (data) {
          this.setState({
            isLoading: false,
            isError: false,
            isSuccess: true,
          });
          const accessToken = data.accessToken;
          const refreshToken = data.refreshToken;
          localStorage.setItem("accessToken", accessToken);
          localStorage.setItem("refreshToken", refreshToken);
        } else {
          this.catchError('Invalid Response');
        }
      })
      .catch((error) => {
        this.catchError(error);

      });

  };

  public catchError(error: any) {
    this.setState({
      isLoading: false,
      isError: true,
      isSuccess: false,
    });
    // console.log(error);

  }
  public catchNok(response: Response) {
    this.setState({
      isLoading: false,
      isError: true,
      isSuccess: false,
    });

  }

  private ensureDataFetched() {

    fetch(
      process.env.REACT_APP_API_HOST +
      `/CabsBill/userprofile`,
      {
        method: "GET",
        credentials: "include",
        headers: {
          pragma: "no-cache",
          "cache-control": "no-cache",
          'Authorization': 'Bearer ' + localStorage.getItem("accessToken"),
          'Content-Type': 'application/x-www-form-urlencoded'
        },
      }
    )
      .then((response) => response.json() as Promise<UserProfile[]>)
      .then((data) => {

        this.setState({
          id: data[0].id,
          currentModel: data[0],
          isLoading: false,
        });
      })
      .catch(() => {
        this.setState({ isLoading: false, isError: true, isSuccess: false });
      });
  }


  public render() {
    return (

      <div style={{ maxWidth: "500px" }}>
        {this.state.isError === true && <Alert color="danger">There was an error with your transaction. </Alert>}
        {this.state.isSuccess === true && <Alert color="success">Your update was saved. </Alert>}
        {this.state.currentModel && <AvForm
          onValidSubmit={this.handleValidSubmit}
          onInvalidSubmit={this.handleInvalidSubmit}
        >
          <div className="d-flex flex-row">

            <div className="form-group" style={{ marginLeft: "8px", marginBottom: "0px" }}>
              <Label className="mb-1 mt-2">Company Name
              </Label>
              <h5 className="ml-2">
                {/* <Badge> */}
                {this.state.currentModel && this.state.currentModel.companyname}
                {/* </Badge> */}
              </h5>
            </div>
          </div>

          <div className="d-flex flex-row">

            <div className="d-flex flex-col m-2">
              <AvField
                name="Name"
                label="Contact Name"
                type="text"
                value={this.state.currentModel && this.state.currentModel.name}
                validate={{
                  required: { value: true, errorMessage: 'Please enter a Name' },
                }}
              />
            </div>

            <div className="d-flex flex-col m-2">
              <AvField
                name="username"
                label="Username"
                type="text"
                value={this.state.currentModel && this.state.currentModel.username}

                validate={{
                  required: { value: true, errorMessage: 'Please enter a userName' },
                }}
              /> </div>
          </div>

          <div className="d-flex flex-row">
            <div className="d-flex flex-col m-2">
              <AvField
                name="email"
                label="Contact Email"
                type="text"
                value={this.state.currentModel && this.state.currentModel.email}

                validate={{
                  required: { value: true, errorMessage: 'Please enter a valid email' },
                  email: true,
                }}
              /> </div>
            <div className="d-flex flex-col m-2">
              <AvField
                name="phone"
                label="Contact Phone"
                type="tel"
                value={this.state.currentModel && this.state.currentModel.phone}
                validate={{
                  required: { value: true, errorMessage: 'Please enter a Contact Phone Number' },
                }}
              /> </div> <div className="d-flex flex-col m-2">

            </div>
          </div>
          <div className="d-flex flex-row">
            {this.state.currentModel.isprimary && this.state.currentModel.isprimary === true && <div className="d-flex flex-col m-2">
              <AvField
                name="brnflag"
                label="Bill Ready Email- Yes, please send me a monthly email reminder that my bill is ready."
                type="checkbox"
                value={this.state.currentModel && this.state.currentModel.brnflag}

              /></div>
            }
            {/* <div className="d-flex flex-col m-2">
              <AvField
                name="isprimary"
                label="IsPrimary"
                type="checkbox"
                value={this.state.currentModel && this.state.currentModel.isprimary}

              /></div> */}
          </div>

          <div className="d-flex flex-wrap flex-row justify-content-between">
            <div className="d-flex flex-col">
              <button className="btn btn-inverse btn-primary btn-sm" id="submit"><strong>SUBMIT</strong></button>
            </div>
            <div className="d-flex flex-col">
              <em><a href="/cabsbillportal/welcome">
                {/* <Link onClick={() => {window.location.href = "/cabsbillportal/welcome" }} to="/Welcome"> */}
                Reset Password
              </a></em>
            </div>
          </div>
        </AvForm>
        }
        <LoadingModal
          isLoading={this.state.isLoading}
        ></LoadingModal>
      </div>
    );
  }
}
